<template>
  <v-container>
    <v-row>
      <v-col>
        <ExportCard />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <ChartCard />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ChartCard from "./LedgerAggregate/ChartCard.vue";
import ExportCard from "./LedgerAggregate/ExportCard.vue";

export default {
  components: { ExportCard, ChartCard },
};
</script>
